import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import Plus from "./../../Assets/images/plusIcon.png"
import { useNavigate } from 'react-router-dom';
import { FiPrinter } from "react-icons/fi";
import ApiService from '../../services/apiService';

const MessageList = () => {
    const [rowData, setRowData] = useState([]);

    const Comparison = [
        { headerName: 'Sr No', field: 'requisitionNo',  minWidth: 310 },
        { headerName: 'Message From', field: 'location',  minWidth: 310 },
        { headerName: 'Message', field: 'location',  minWidth: 450 },
        { headerName: 'Message To', field: 'costCenter1',  minWidth: 210 },
        { headerName: 'Date', field: 'createdDate',  minWidth: 110 },
    ];

    return (
        <div className='px-5'>
            <div className='brderbox'>
                <div className="ag-theme-quartz" style={{ height: 600 }}>
                    <AgGridReact
                        getRowStyle={(params) => {
                            if (params.node.rowIndex % 2 === 0) {
                                return { background: '#F0EDF5' };
                            } else {
                                return { background: '#fff' };
                            }
                        }}
                        enableFilter={true}
                        floatingFilter={true}
                        rowSelection={'single'}
                        columnDefs={Comparison}
                        pagination={false}
                        suppressExcelExport={true}
                        domLayout='autoHeight'
                        suppressRowClickSelection={true}
                    />
                </div>
            </div>
        </div>
    );
};
export default MessageList; 